var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiretriz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.6,19.6H8.9c-0.3,0-0.5-0.2-0.6-0.4c-0.1-0.2,0-0.5,0.1-0.7l2.9-2.9l-1,0c-0.4,0-0.7-0.3-0.7-0.7 c0-0.4,0.3-0.7,0.7-0.7h0l2.6,0c0.3,0,0.5,0.2,0.6,0.4c0.1,0.2,0,0.5-0.1,0.7l-2.9,2.9h3.8l5.8-5.8l-5.8-5.8h-3.8l2.9,2.9 c0.2,0.2,0.2,0.5,0.1,0.7c-0.1,0.2-0.3,0.4-0.6,0.4l-6.2,0v3.4l0.5,0c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7l-1.2,0 c-0.4,0-0.7-0.3-0.7-0.7v-4.8c0-0.4,0.3-0.7,0.7-0.7l5.3,0L8.5,6.5C8.3,6.3,8.2,6,8.3,5.8c0.1-0.2,0.3-0.4,0.6-0.4h5.7 c0.2,0,0.3,0.1,0.5,0.2l6.4,6.4c0.1,0.1,0.2,0.3,0.2,0.5v0c0,0.2-0.1,0.3-0.2,0.5l-6.4,6.4C15,19.5,14.8,19.6,14.6,19.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiretriz);
export default __webpack_public_path__ + "static/media/diretriz.69e35cfeec6daa908a44c57895902441.svg";
export { ForwardRef as ReactComponent };